import React from 'react'
import { Button } from 'antd'

const paymentConfig = {
  channelType: {
    Alipay: 1, // 支付宝支付
    WeChat: 2 // 微信支付
  },
  vipKind: {
    vip: 1, // 普通会员
    svip: 2, // 超级会员
    vvip: 3 // 高级会员
  },
  paymentType: {
    singleMonth: 0, // 仅买一个月
    singleYear: 1, // 仅买一年
    twoYear: 10, // 买两年
    multipleMonth: 2, // 连续包月
    multipleYear: 3, // 连续包年
    batchDownload: 4, // 单次批量下载照片
    periodQuarter: 9 // 连续包季
  },
  paymentStatus: {
    Unpaid: {
      code: 1,
      msg: '未支付' // 已签约未支付
    },
    Paid: {
      code: 2,
      msg: '支付成功'
    },
    PaymentFail: {
      code: 3,
      msg: '支付失败'
    },
    Refunding: {
      code: 4,
      msg: '退款中'
    },
    Refunded: {
      code: 5,
      msg: '已退款'
    },
    RefundFail: {
      code: 6,
      msg: '退款失败'
    },
    OrderClosed: {
      code: 7,
      msg: '订单已关闭'
    },
    UnSign: {
      code: 8,
      msg: '未签约'
    }
  },
  svipOnlyText: {
    default: '此权益为团队“超级会员”权益，购买基础/高级会员无法享受此权益。',
    webGroupManegerNum:
      '添加3个及以上管理员为团队“超级会员”权益，购买基础/高级会员无法享受此权益。',
    webGroupDepartmentNum:
      '此权益为团队“超级会员”权益，购买基础/高级会员无法享受此权益。',
    WEBGroupWatermarkNum7:
      '添加8个及以上团队水印为团队“高级会员”权益，购买基础会员无法享受此权益。',
    WEBGroupWatermarkNumVvip:
      '添加4个及以上团队水印为团队“高级会员”权益，购买基础会员无法享受此权益。',
    WEBGroupWatermarkNumSvip:
      '添加8个及以上团队水印为团队“超级会员”权益，购买基础会员无法享受此权益。'
  },
  alipayUrlPrefix: 'https://openapi.alipay.com/gateway.do?', // 支付宝支付域名
  initConfig: {
    // 通知框初始数据
    key: 'orderNotification',
    duration: 0,
    className: 'payment-notification'
  },
  infoConfig: {
    message: '请稍后，正在查询订单状态（30s）',
    description: '请您耐心等待',
    duration: 30
  },
  errorConfig: (payment, notification) => {
    return {
      message: '订单状态查询失败',
      description: (
        <div>
          请保证余额充足，并检查订单记录。
          <br />
          若确定支付，请刷新页面，或即使联系客服。
        </div>
      ),
      btn: [
        <Button
          style={{ color: '#333' }}
          onClick={() => {
            payment.orderNotification('info')
          }}
        >
          再次查询
        </Button>,
        <Button
          type="primary"
          style={{ marginLeft: '12px' }}
          onClick={() => {
            notification.destroy()
          }}
        >
          确定
        </Button>
      ]
    }
  },
  warningConfig: (payment) => {
    return {
      message: '订单查询超时',
      description: '若已支付成功，请点击再次查询',
      btn: (
        <Button
          type="primary"
          onClick={() => {
            payment.orderNotification('info')
          }}
        >
          再次查询
        </Button>
      )
    }
  }
}

export default paymentConfig
